export default __webpack_public_path__ + "static/m-process-02-94c032c85d0aeb8be91f62119e4828e8.svg";